import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, XCircle, Percent } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const monthName = (key, style = 'short') => new Date(`${key}-15T12:00:00`).toLocaleString('en-US', { month: style });

export const StatsBar = ({ token, refreshKey }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/owner/stats?months=6`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setStats(r.data))
      .catch(() => setStats([]));
  }, [token, refreshKey]);

  if (!stats || !stats.length) return null;
  const [cur, ...past] = stats;
  const rate = (r) => (r === null ? '—' : `${r}%`);

  return (
    <section className="o-stats" data-testid="owner-stats">
      <div className="o-stats-main">
        <p className="o-stats-label">{monthName(cur.month, 'long')} so far</p>
        <div className="o-stats-row">
          <div className="o-stat st-won"><Trophy size={18} /><strong data-testid="stats-won">{cur.won}</strong><span>Won</span></div>
          <div className="o-stat st-lost"><XCircle size={18} /><strong data-testid="stats-lost">{cur.lost}</strong><span>Lost</span></div>
          <div className="o-stat st-rate"><Percent size={18} /><strong data-testid="stats-win-rate">{rate(cur.win_rate)}</strong><span>Win rate</span></div>
        </div>
      </div>
      <div className="o-stats-history" data-testid="stats-history">
        {past.slice().reverse().map((m) => (
          <div key={m.month} className="o-stats-month" data-testid={`stats-month-${m.month}`}>
            <div className="o-bar"><span style={{ height: `${m.win_rate ?? 0}%` }} /></div>
            <strong>{rate(m.win_rate)}</strong>
            <small>{monthName(m.month)} · {m.won}W/{m.lost}L</small>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
